/* eslint-disable  react/button-has-type */
import cx from 'classnames';
import { FC, ReactElement } from 'react';

import classes from './Button.module.scss';
import { ButtonProps, IButtonProps, ILinkProps } from './Button.types';

export const Button: FC<ButtonProps> = ({
  className,
  type = 'button',
  variant = 'primary',
  children,
  ...props
}): ReactElement => {
  const { href = '' } = props as ILinkProps;

  if (type === 'a') {
    const { ...rest } = props as ILinkProps;
    return (
      <a
        className={cx(
          classes.button,
          classes[`button--variant-${variant}`],
          className,
        )}
        href={href}
        {...rest}
      >
        {children}
      </a>
    );
  }

  const { customRef, ...rest } = props as IButtonProps;

  return (
    <button
      className={cx(
        classes.button,
        classes[`button--variant-${variant}`],
        className,
      )}
      ref={customRef}
      {...rest}
      onClick={(event) => {
        rest.onClick?.(event);
      }}
    >
      {children}
    </button>
  );
};
